module.exports = __webpack_public_path__ + "static/media/codicon.22349029.ttf";